import * as mobile_functions from './_sticky.js';

document.addEventListener("DOMContentLoaded", function () {
	let nav_breakpoint = '1280px';
	const focusTrap = require('focus-trap');

	let mobile_trap = focusTrap.createFocusTrap(['header', '#mobile-menu'], {
		clickOutsideDeactivates: true
	});
	let sub_menu_trap = false;

	document.addEventListener('click', function (event) {

		//if the mobile nav is visible
		if(window.matchMedia('(max-width: ' + nav_breakpoint + ')').matches) {

			// Only run on our select menu
			if (!event.target.matches('.hamburger-menu')) return;

			let mobile_menu = document.getElementById('mobile-menu');
			let mobile_toggle = document.getElementById('mobile-toggle');

			if(!document.body.classList.contains('mobile-menu-active')) {
				mobile_functions.apply_header_offset();
			}

			//add a class indicating it's been toggled
			mobile_toggle.classList.toggle('animate');
			document.body.classList.toggle('mobile-menu-active');

			if(document.body.classList.contains('mobile-menu-active') && mobile_menu) {
				mobile_menu.classList.remove('invisible');

				setTimeout(function() {
					mobile_menu.classList.remove('scroll-lock');
				}, 300);

				mobile_trap.activate();
			} else if(mobile_menu) {

				if(!document.body.classList.contains('mobile-menu-active')) {
					mobile_functions.remove_header_offset();
				}

				setTimeout(function() {
					mobile_menu.classList.add('invisible');
					mobile_menu.classList.add('scroll-lock');

					let active_link_items = mobile_menu.querySelectorAll('.keyboard-nav-toggle, .sliding-submenu');

					if(active_link_items.length) {
						for(let i = 0; i < active_link_items.length; i++) {
							active_link_items[i].classList.remove('keyboard-nav-toggle');
							active_link_items[i].classList.remove('sliding-submenu');
						}
					}

					mobile_trap.deactivate();

					if(sub_menu_trap) {
						sub_menu_trap.deactivate();
					}
				}, 300);
			}

			//if the mobile menu has now been closed...
			if(!document.body.classList.contains('mobile-menu-active')) {

				//if our mobile trap exists
				if(mobile_trap) {

					//deactivate it
					mobile_trap.deactivate();
				}

				//if our sub menu trap exists
				if(sub_menu_trap) {

					//deactivate it
					sub_menu_trap.deactivate();
				}
			}
		}
	});

	document.addEventListener('click', function (event) {

		//if the mobile nav is visible
		if(window.matchMedia('(max-width: ' + nav_breakpoint + ')').matches) {

			// Only run on our select menu
			if (!event.target.matches('.menu-item-has-children')) return;
			mobile_navigation_controller(event.target);
		}
	});

	document.addEventListener('click', function (event) {

		//if the mobile nav is visible
		if(window.matchMedia('(max-width: ' + nav_breakpoint + ')').matches) {

			// Only run on our select menu
			if (event.target.tagName == 'A' && !event.target.parentNode.matches('.menu-item-has-children')) return;

			let href = event.target.getAttribute("href");

			if(href == '#' || href == '#_') {
				mobile_navigation_controller(event.target.parentNode);
			}
		}
	});

	document.addEventListener('click', function (event) {

		//if the mobile nav is visible
		if(window.matchMedia('(max-width: ' + nav_breakpoint + ')').matches) {

			// Only run on our select menu
			if (!event.target.matches('.sub-menu-back')) return;
			mobile_navigation_controller(event.target.parentNode.parentNode);
		}
	});

	function mobile_navigation_controller(li) {
		//add a class indicating it's been toggled
		li.classList.toggle('keyboard-nav-toggle');

		if(!li.classList.contains('back-added')) {
			li.children[1].innerHTML = '<button class="sub-menu-back"><span class="icon-chevron"></span>Back</button>' + li.children[1].innerHTML;
			li.classList.add('back-added');
		}

		if(li.classList.contains('keyboard-nav-toggle')) {
			sub_menu_trap = focusTrap.createFocusTrap(['header', li], {
				clickOutsideDeactivates: true
			});

			if(sub_menu_trap) {
				sub_menu_trap.activate();
			}
		} else if(sub_menu_trap) {
			sub_menu_trap.deactivate();
		}

		li.parentNode.classList.toggle('sliding-submenu');
	}
});